import { render, staticRenderFns } from "./tdsBreakupOldRegimePopup.vue?vue&type=template&id=ba1db7ee&scoped=true"
import script from "./tdsBreakupOldRegimePopup.vue?vue&type=script&lang=js"
export * from "./tdsBreakupOldRegimePopup.vue?vue&type=script&lang=js"
import style0 from "./tdsBreakupOldRegimePopup.vue?vue&type=style&index=0&id=ba1db7ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba1db7ee",
  null
  
)

export default component.exports